import { Component } from "vue";

export default [
  {
    path: "login",
    component: (): Promise<Component> => import("../components/Login.vue"),
    name: "login",
    meta: { requiresAuth: false },
  },
  {
    path: "autologin",
    component: (): Promise<Component> => import("../components/Autologin.vue"),
    name: "autologin",
    meta: { requiresAuth: false },
  },
  {
    path: "outdated-password",
    component: (): Promise<Component> =>
      import("../components/OutdatedPassword.vue"),
    name: "outdated-password",
  },
  {
    path: "callback-login",
    component: (): Promise<Component> =>
      import("../components/CallbackLogin.vue"),
    name: "callback-login",
    meta: { requiresAuth: false },
  },
  {
    path: "register-lender",
    component: (): Promise<Component> =>
      import("../components/RegisterLender.vue"),
    name: "register-lender",
    meta: { requiresAuth: false },
  },
  {
    path: "register-borrower",
    component: (): Promise<Component> =>
      import("../components/RegisterBorrower.vue"),
    name: "register-borrower",
    meta: { requiresAuth: false },
  },
];
